<div class="FcAgEditor__MenuItem--IconContainer" [innerHTML]="icon | sanitizeHtml" (mousedown)="onMouseDown($event)"
     [title]="title">
</div>

<!-- popup -->
<div *ngIf="showPopup" class="FcAgEditor__Popup insert-link">
    <form class="FcAgEditor__Popup--Form" [formGroup]="form" (ngSubmit)="insertLink($event)">

        <div class="FcAgEditor__Popup--FormGroup">
            <div class="FcAgEditor__Popup--Col">
                <label class="FcAgEditor__Popup--Label">{{getLabel('url')}}</label>
                <input type="href" id="href" formControlName="href" autofocus autocomplete="off"/>
                <div *ngIf="href.invalid" class="FcAgEditor__HelpText FcAgEditor__HelpText--Error">
                    {{ href.errors?.['pattern'] && 'Please enter valid url.' }}
                </div>
            </div>
        </div>

        <div class="FcAgEditor__Popup--FormGroup">
            <div class="FcAgEditor__Popup--Col">
                <label>{{getLabel('text')}}</label>
                <input type="text" formControlName="text" autocomplete="off"/>
                <div *ngIf="text.invalid" class="FcAgEditor__HelpText FcAgEditor__HelpText--Error">
                    {{ text.errors?.['required'] && 'This field is required' }}
                </div>
            </div>
        </div>

        <div class="FcAgEditor__Popup--FormGroup">
            <div class="FcAgEditor__Popup--Col">
                <label class="checkbox-button">
                    <input type="checkbox" formControlName="openInNewTab"/>
                    {{getLabel('openInNewTab')}}
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>

        <button type="submit" [disabled]="!form.valid">{{getLabel('insert')}}</button>

    </form>
</div>
